var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "item-upsell-container" }, [
    _vm.upsell
      ? _c(
          "div",
          {
            staticClass: "content-message",
            attrs: { "aria-label": _vm.mobileMessage, tabindex: "0" }
          },
          [_vm._v("\n\t\t" + _vm._s(_vm.mobileMessage) + "\n\t")]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.item
      ? _c("div", { staticClass: "content-image" }, [
          _c("img", {
            attrs: { src: _vm.getItemImage, alt: _vm.item.name + " image" }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "content-actions" },
      [
        _c("BaseButton", {
          attrs: { title: "Yes! 👍", bigBtn: true },
          nativeOn: {
            click: function($event) {
              return _vm.confirmUpsell($event)
            }
          }
        }),
        _vm._v(" "),
        _c("BaseButton", {
          attrs: { title: "No, thank you.", bigBtn: true },
          nativeOn: {
            click: function($event) {
              return _vm.rejectUpsell($event)
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5812c990", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5812c990","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/CartItemUpsell.vue
// module id = null
// module chunks = 